/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMembersEditRights } from './WebApiModelsEnumerationTypesMembersEditRights';
import {
    WebApiModelsEnumerationTypesMembersEditRightsFromJSON,
    WebApiModelsEnumerationTypesMembersEditRightsFromJSONTyped,
    WebApiModelsEnumerationTypesMembersEditRightsToJSON,
} from './WebApiModelsEnumerationTypesMembersEditRights';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListDto
 */
export interface WebApiCustomListsDtoCustomListDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    schemaJson?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    listType?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMembersEditRights}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    membersEditRights?: WebApiModelsEnumerationTypesMembersEditRights;
    /**
     * 
     * @type {Date}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    updatedBy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListDto
     */
    createdBy?: number | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListDtoFromJSON(json: any): WebApiCustomListsDtoCustomListDto {
    return WebApiCustomListsDtoCustomListDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'schemaJson': !exists(json, 'schemaJson') ? undefined : json['schemaJson'],
        'listType': !exists(json, 'listType') ? undefined : json['listType'],
        'membersEditRights': !exists(json, 'membersEditRights') ? undefined : WebApiModelsEnumerationTypesMembersEditRightsFromJSON(json['membersEditRights']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
    };
}

export function WebApiCustomListsDtoCustomListDtoToJSON(value?: WebApiCustomListsDtoCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'companyId': value.companyId,
        'schemaJson': value.schemaJson,
        'listType': value.listType,
        'membersEditRights': WebApiModelsEnumerationTypesMembersEditRightsToJSON(value.membersEditRights),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'updatedBy': value.updatedBy,
        'createdBy': value.createdBy,
    };
}

